export * from './propTypeSchemas';

export const ApiErrorMessages = {
    ENTITY_NOT_FOUND: 'ENTITY_NOT_FOUND',
    FORBIDDEN: 'FORBIDDEN',
    INVALID_PERMISSIONS: 'INVALID_PERMISSIONS', // used for MSGS. same meaning as PERMISSION_DENIED
    PERMISSION_DENIED: 'PERMISSION_DENIED', // used for MSGGQL. same meaning as INVALID_PERMISSIONS
    MALFORMED_REQUEST: 'MALFORMED_REQUEST',
    NOT_LOGGED_IN: 'NOT_LOGGED_IN',
    PAGE_TOKEN_EXPIRED: 'PAGE_TOKEN_EXPIRED',
    PAGE_TOKEN_INVALID: 'PAGE_TOKEN_INVALID',
    STALE_REQUEST: 'STALE_REQUEST',
    BAD_USER_INPUT: 'BAD_USER_INPUT', // used for MSGGQL. same meaning as MALFORMED_REQUEST
};

export const ApiStatusCodes = {
    GONE: 410,
};

export const COOKIES_EXPIRATION_TIME_MS = 5 * 365 * 24 * 60 * 60 * 1000; // 5 years

export const MessagingAppStatus = {
    CONVERSATIONS_LOADED: 'STATUS::CONVERSATIONS_LOADED',
    FAILED_TO_LOAD_CONVERSATION: 'STATUS::FAILED_TO_LOAD_CONVERSATION',
    FAILED_TO_LOAD_CONVERSATIONS: 'STATUS::FAILED_TO_LOAD_CONVERSATIONS',
    GENERIC_ERROR: 'STATUS::GENERIC_ERROR',
    LOADING_CONVERSATION: 'STATUS::LOADING_CONVERSATION',
    LOADING_CONVERSATIONS: 'STATUS::LOADING_CONVERSATIONS',
    NOT_READY: 'STATUS::NOT_READY', // No User Data / SessionContext
    NO_CONVERSATIONS: 'STATUS::NO_CONVERSATIONS',
    READY: 'STATUS::READY', // User Data Validated
    VIEWING_CONTEXT_INFO: 'STATUS::VIEWING_CONTEXT_INFO',
    VIEWING_CONVERSATION: 'STATUS::VIEWING_CONVERSATION',
    VIEWING_CONVERSATIONS: 'STATUS::VIEWING_CONVERSATIONS',
};

export const Delays = {
    CHANNEL_PAGINATE_DELAY_MS: 1000,
    CHANNEL_POLL_DELAY_MS: 90000,
    GLOBAL_LOADER_DELAY_MS: 200,
    MESSAGE_POLL_DELAY_MS: 90000,
};

export const ActionType = {
    ARCHIVE: 'Archive',
    RESTORE: 'Restore',
    REPORT: 'Report',
    REPORT_SPAM: 'Report_Spam',
    VIEW_DETAILS: 'View_Details',
    MOVE_TO_SPAM: 'Move_to_Spam',
    RESUME_INVITE_INTERESTED: 'Resume_Invite_Interested',
    RESUME_INVITE_DECLINED: 'Resume_Invite_Declined',
    RESUME_INVITE_DECLINED_AND_ARCHIVED: 'Resume_Invite_Declined_and_Archived',
    REAL_TIME_CONNECTION_STATUS: 'Real_Time_Connection_Status',
    GENERATE_MESSAGE: 'Generate_Message',
};

export const ModalTypes = {
    POST_APPLY_SEND_MESSAGE_NOT_ALLOWED_NOTICE: 'postApplySendMessageNotAllowedNotice',
    PRE_APPLY_SEND_MESSAGE_NOT_ALLOWED_NOTICE: 'preApplySendMessageNotAllowedNotice',
    MODERATION_REQUEST_FORM: 'moderationRequestForm',
    ATTACHMENT_TOTAL_SIZE_LIMIT_EXCEEDED: 'attachmentTotalSizeLimitExceededNotice',
    ATTACHMENT_SINGLE_SIZE_LIMIT_EXCEEDED: 'attachmentSingleSizeLimitExceededNotice',
    ATTACHMENT_INVALID_FILE: 'attachmentInvalidFileNotice',
    ATTACHMENT_SERVER_ERROR: 'attachmentServerErrorNotice',
    ATTACHMENT_NO_INTERNET_CONNECTION: 'attachmentNoInternetConnectionNotice',
    REZCON_JOB_DESCRIPTION: 'rezconJobDescription',
    CALL_BACK: 'callBack',
    INTERVIEW: 'interview',
    UNEDITED_SUGGESTED_MESSAGE: 'uneditedSuggestedMessage',
    RESPONSIVENESS_CANDIDATE_STATUS_EARNED_MODAL: 'ResponsivenessCandidateStatusEarnedModal',
};

export const AdditionalFields = {
    CLASSIFICATIONS: 'classifications',
};

export { MessagingNotices, MobileNotices } from './noticeConstants';
export { ReservedConversationSids } from './conversationConstants';

// div container id for the hydration part of messaging app(without gnav)
export const MESSAGING_ROOT_ID = 'messaging-root';

export const JOB_DATA_SERVICE_CONTEXT = 'REQERR::JRS';
